import BaseFinisherViewModel from '../BaseFinisherViewModel'
import ObservableTrotFinisher from '@classic/Betting-v2/Model/Observables/ObservableTrotFinisher'
import ObservableResultsPage from '@classic/Betting-v2/Model/Observables/ObservableResultsPage'
import { MatchedFieldSummaryResults } from '@core/Areas/Racing/Components/FieldSummary/MatchedFieldSummaryResults'
import { MatchedFieldSummary } from '@core/Areas/Racing/Components/FieldSummary/MatchedFieldSummary'

export interface Params {
  raceInformation: ObservableResultsPage
  finisher: ObservableTrotFinisher
  showField: boolean
}

export class TrotFinisherViewModel extends BaseFinisherViewModel {
  public MatchedFieldSummaryResults: typeof MatchedFieldSummaryResults
  public MatchedFieldSummary: typeof MatchedFieldSummary

  constructor(params: Params) {
    super(params)
    this.MatchedFieldSummaryResults = MatchedFieldSummaryResults
    this.MatchedFieldSummary = MatchedFieldSummary
  }
}
